import { ProductTreeType } from './../products/products.component';
import { ActivityCapabilitiesType, ActivityTask, ActivityTaskType, TaskStatus } from './../../model/TaskStatus';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, of } from 'rxjs';
import { DiscoveredProduct, ProductComponent, ProductExt, ProductInstance, PatchExt, ProductInstanceRow, UpdateAnalysisRequest } from 'src/app/model/Product';
import { DataService } from 'src/app/service/data.service';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { tap, finalize, catchError } from 'rxjs/operators';
import { ProductDataType, ProductsComponent } from '../products/products.component';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { Events, WebsocketService } from 'src/app/service/websocket.service';
import { Modal } from '../controls/modal/modal.service';
import { ActivityService } from 'src/app/service/activity.service';
import { Agent } from 'src/app/model/Agent';
import { InstanceDetailsComponent } from '../dialogs/instance-details/instance-details.component';
import { ProductResyncComponent } from '../dialogs/product-resync/product-resync.component';
import { ModalMessageComponent } from '../controls/modal-message/modal-message.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { PageCount, PageEvent } from '../controls/pagination/pagination.component';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { Utils } from 'src/app/utils';
import { SolutionService } from 'src/app/service/solution.service';

enum UAState {INIT, VIEW_REPORT}
enum UAReportState {OVERVIEW, HOW_TO_UNDERSTAND, SUMMARY, REPORT}

@Component({
    selector: 'app-product-component-ua',
    templateUrl: './product-component-ua.component.html',
    styleUrls: ['./product-component-ua.component.css'],
    standalone: false
})
export class ProductComponentUaComponent extends ProductsComponent implements OnInit {

  TabColor = TabColor;
  instancesTab = new Tab('otsc-about-dialog_contact_info_tab', $localize`Instances`, undefined, false);
  tabs: Tab[] = [this.instancesTab];

  overviewTab = new Tab('otsc-ua-report-overview-tabitem', $localize`Overview`, undefined, false);
  summaryTab = new Tab('otsc-ua-report-summary-tabitem', $localize`Summary`, undefined, false);
  howToTab = new Tab('otsc-ua-report-howto-tabitem', $localize`How to Understand`, undefined, false);
  reportTab = new Tab('otsc-ua-report-table-tabitem', $localize`Report`, undefined, false);
  uaReportActiveTab: UAReportState = UAReportState.OVERVIEW;
  uaReportTabs: Tab[] = [this.overviewTab, this.summaryTab, this.howToTab, this.reportTab];
  
  componentTableCols: DataTableColumn[] = [];
  componentTableRows: DataTableRow[] = [];
  activeComponent:ProductComponent;
  activeProductInstances:Record<string, ProductInstance[]>;
  productId:number;
  platform:string;
  activeProduct:ProductExt;
  title:string;
  setupid:string;
  currEnvId:number;
  isQuickAnalysisRequired = false;
  isMasterSystemSelected = true;
  isReload:boolean = false;
  isMasterSystemOnline:boolean = true;
  isSupportHotfix = false;

  state: UAState = UAState.INIT;
  UAState = UAState;
  selectedInstanceRows:DataTableRow[] = [];
  uaRequestMap = new Object();
  availablePatches:PatchExt[] = [];
  targetUpdate:PatchExt;
  currentUpdate:PatchExt;
  selectedInstancesFromPreviousPage:ProductInstanceRow[] = [];  

  isAnalyzing:boolean = false;
  isAnalyzed:boolean = false;

  //delta report
  uaTableCols: DataTableColumn[] = Array<DataTableColumn>(
                                    new DataTableColumn("path", $localize`Path`, ColumnType.STRING, true, "70", ColumnSort.DESC),
                                    new DataTableColumn("origin", $localize`Update/Hotfix`, ColumnType.STRING, false, "15"),
                                    new DataTableColumn("type", $localize`Type`, ColumnType.STRING, false, "15"))
  uaTableRows: DataTableRow[] = [];
  uaReportState: UAReportState = UAReportState.OVERVIEW;
  UAReportState = UAReportState;
  currentDeltaReport:any;
  itemsPerPage: number = PageCount.TWENTYFIVE;
  startingIndex:number = 0;
  sortingCol:DataTableColumn = this.uaTableCols[0];
  uaReportNumInstances:number = 0;
  uaReportNumInstancesError:number = 0;
  @ViewChild('scrollbarReportRef') scrollRef: NgScrollbar;
  
  constructor(protected eventService: EventService,
              protected authService:AuthenticationService,
              protected siService:SoftwareInventoryService,
              protected dataService:DataService,
              protected wsService: WebsocketService,
              protected router: Router,
              protected modal: Modal,
              protected activityService: ActivityService,
              private route: ActivatedRoute,
              protected solutionService: SolutionService) {
    super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
    //if instances were passed in
    if(this.router.currentNavigation() &&
        this.router.currentNavigation().extras && 
        this.router.currentNavigation().extras.state && 
        this.router.currentNavigation().extras.state.instances){
      this.selectedInstancesFromPreviousPage = this.router.currentNavigation().extras.state.instances;
    }else{
      this.selectedInstancesFromPreviousPage = undefined;
    }
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.setupid = params['setupid'];
    });

    this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
      if(data && data.type == ProductDataType.AgentManifest){
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if(data && (data.type == ProductDataType.General || data.type == ProductDataType.Updates || data.type == ProductDataType.QuickAnalysis)){
        this.solutionInfo = data.solutionInfo;
        this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
        this.isReload = this.isReload || this.currEnvId != this.solutionInfo.currentEnvironment.id;
        this.platform = undefined;
        this.isMasterSystemOnline = true;
        const discoveredProductGroup : DiscoveredProduct[] = data.discoveredProductGroup;
        this.uaRequestMap = new Object();
        this.uaReportNumInstances = 0;
        this.uaReportNumInstancesError = 0;
        this.isAnalyzed = false;

        //get platform
        for(let i =0; i < discoveredProductGroup.length; i++) {
          let foundProd:ProductExt[] = (discoveredProductGroup[i].products.filter((prod:ProductExt) => {
            return prod.id == this.productId;
          }))
          if(foundProd.length > 0){
            this.availablePatches = foundProd[0].availablePatches;
            if(this.availablePatches.length > 0){
              this.targetUpdate = this.availablePatches[0];
              this.currentUpdate = this.availablePatches[0];
            }
            this.platform = foundProd[0].platform;
            this.isSupportHotfix = foundProd[0].supportHotfix;

            if(this.isSupportHotfix){
              this.isQuickAnalysisRequired = !foundProd[0].isQuickAnalysisValid;
              this.isMasterSystemOnline = foundProd[0].isMasterSystemOnline;
              if(this.componentTableCols.length == 0){
                this.componentTableCols = Array<DataTableColumn>(
                  new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "29.5", ColumnSort.DESC),
                  new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "19.5"),
                  new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "10"),
                  new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "15"),
                  new DataTableColumn("agentStatus", $localize`Agent status`, ColumnType.STATUSEXT, false, "8"),
                  new DataTableColumn("viewReport", $localize`Actions`, ColumnType.LINK, false, "18"),
                );
              }
            }
          }
        };

        if(this.platform && this.isReload && this.isSupportHotfix){
          this.currEnvId = this.solutionInfo.currentEnvironment.id;
          this.componentTableRows = [];
          this.initView();          
        }else if(this.platform === undefined){
          this.router.navigate(['..'], { relativeTo: this.route });
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.CSUpdateAnalysis){
        if(this.isPendingTransaction(msg.headers.transactionId, false)){
          let uaRequest = JSON.parse(msg.body.msg);
          this.uaRequestMap[uaRequest.macAddress] = uaRequest;

          for (let uaRequest of Object.values(this.uaRequestMap)) {
            uaRequest.instances.forEach((instance:any) => {
              //check if completed
              if(instance.status.completed && instance.status.success){
                this.componentTableRows.forEach((instanceRow:DataTableRow) => {
                  //update row
                  if(instanceRow.data.macAddress == uaRequest.macAddress && instanceRow.data.installPath == instance.OTHome){
                    instanceRow.loading = false;
                    instanceRow.data.viewReport = $localize`View report`;
                  }
                });
              }else if(instance.status.completed && !instance.status.success){
                this.uaReportNumInstancesError++;
              }
            });
          }

          if(this.isUAComplete()){
            this.isAnalyzing = false;
            this.componentTableRows.forEach((row:DataTableRow) => {
              row.disableCheckbox = false;
            });
            this.isAnalyzed = true;
            this.removeTransaction(msg.headers.transactionId);
          }
        }
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
      } else if(msg.eventType == Events.ActivityCapabilities){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.activityCapabilities = JSON.parse(msg.body.msg);
          if(this.activityCapabilities.activityType == ActivityCapabilitiesType.ENABLE_PRODUCT){
            this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
              if(task.type == ActivityTaskType.VALIDATE_HOST){
                task.completed = true;
                task.success = true;
                task.isCurrentTask = false;
              }else if(task.type == ActivityTaskType.VALIDATE_COMMUNICATIONS){
                task.completed = true;
                task.success = true;
                task.isCurrentTask = true;
              }else{
                task.isCurrentTask = false;
              }
            });
            this.isReload = true;
            this.analyzeMasterSystem(this.solutionInfo, this.activityCapabilities, this.activeProduct);
          }
        }
      }
    });
  }

  initView():void {
    this.isLoading = true;
    this.isReload = false;

    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;

        let foundComponents = this.activeProduct.components.filter((comp:ProductComponent) => {return comp.setupid === this.setupid});

        if(foundComponents.length > 0){
          this.selectedInstanceRows = [];
          this.activeComponent = foundComponents[0];
          this.activeProductInstances = this.activeProduct.instances;
          this.componentTableRows = [];
          this.title = $localize`${this.activeProduct.name} ${this.activeProduct.version} Component`;
          this.dataService.sendData({type: ProductDataType.Title, title: this.title});
          this.dataService.sendData({type: ProductDataType.SelectTree, select: {type: ProductTreeType.COMPONENT,
                                                                            productGroupId: this.activeProduct.groupId,
                                                                            productId: this.productId, 
                                                                            setupid: this.activeComponent.setupid}});

          let masterSystemCounter:number = 0;

          for (let key in this.activeProductInstances) {  
            this.activeProductInstances[key].forEach((instance:ProductInstance) => {
              if(instance.isMasterInstance){
                masterSystemCounter++;
                this.isMasterSystemSelected = this.isSupportHotfix ? masterSystemCounter == 1 : true;
              }

              let instanceAgent:Agent[] = this.solutionInfo.currentEnvironment.agents.filter((agent:Agent) => {
                return agent.macAddress == key;
              });

              if(instanceAgent.length > 0){
                instance.agent = instanceAgent[0];
              }
            
              //check if the instance were selected from the previous page
              var isSelected:boolean = false;

              if(this.selectedInstancesFromPreviousPage && this.selectedInstancesFromPreviousPage.length > 0){
                let matchedInstance:ProductInstance[] = this.selectedInstancesFromPreviousPage.filter((selectedInstance: ProductInstance) => {
                  return selectedInstance.system == instance.system && selectedInstance.installPath == instance.installPath;
                });

                isSelected = matchedInstance.length > 0;
              }else{
                isSelected = true;
              }

              let actions:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, instance, false, true)];
              let row:DataTableRow = new DataTableRow({
                                                        system: instance.system,
                                                        installPath: instance.installPath,
                                                        version: instance.version,
                                                        platform: instance.platform,
                                                        instance: instance,
                                                        macAddress: instance.macAddress,
                                                        agentStatus: this.getAgentStatus(instance.agent),
                                                        viewReport: '',
                                                        metadata: instance.metadata,
                                                      }, 
                                                      actions, 
                                                      this.isSupportHotfix && !this.isMasterSystemSelected, 
                                                      isSelected, 
                                                      false, 
                                                      $localize`Change primary system to resolve the issue`);
              row.disableCheckbox = !this.isMasterSystemOnline;
              this.componentTableRows.push(row);
              if(row.selected){
                this.selectedInstanceRows.push(row);
              }
            });
          }
        }else{
          this.router.navigate(['products/overview']);
        }          
      }),
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  viewReport(row:DataTableRow): void {
    this.currentDeltaReport = undefined;

    if(row.data.viewReport){
      if(this.uaRequestMap[row.data.macAddress] && this.uaRequestMap[row.data.macAddress].instances && this.uaRequestMap[row.data.macAddress].instances.length > 0){
        for(let i = 0; i < this.uaRequestMap[row.data.macAddress].instances.length; i++){
          if(this.uaRequestMap[row.data.macAddress].instances[i].OTHome == row.data.installPath){
            this.currentDeltaReport = this.uaRequestMap[row.data.macAddress].instances[i].report;
            this.uaTableCols[0].sortDirection = ColumnSort.DESC;
            this.uaTableCols[0].sorted = true;
            this.sortingCol = this.uaTableCols[0];
            this.resetUACols();
            this.getUAFiles(PageCount.TWENTYFIVE, 0, this.sortingCol);
            break;
          }
        }
      }

      this.uaReportState = UAReportState.OVERVIEW;
      this.state = UAState.VIEW_REPORT;
      this.componentTableRows.forEach((tableRow:DataTableRow) => {
        if(tableRow.data.macAddress == row.data.macAddress && tableRow.data.installPath == row.data.installPath){
          tableRow.data.viewReportSelected = true;
        }else{
          tableRow.data.viewReportSelected = false;
        }
      });
      
    }
  }

  switchReport(row:DataTableRow): void {
    this.currentDeltaReport = undefined;

    if(this.uaRequestMap[row.data.macAddress] && this.uaRequestMap[row.data.macAddress].instances && this.uaRequestMap[row.data.macAddress].instances.length > 0){
      for(let i = 0; i < this.uaRequestMap[row.data.macAddress].instances.length; i++){
        if(this.uaRequestMap[row.data.macAddress].instances[i].OTHome == row.data.installPath){
          this.currentDeltaReport =  this.uaRequestMap[row.data.macAddress].instances[i].report;
          this.uaReportState = UAReportState.OVERVIEW;
          this.uaTableCols[0].sortDirection = ColumnSort.DESC;
          this.uaTableCols[0].sorted = true;
          this.sortingCol = this.uaTableCols[0];
          this.resetUACols();
          this.getUAFiles(PageCount.TWENTYFIVE, 0, this.sortingCol);
          
          if(this.currentDeltaReport && this.scrollRef){
            this.scrollRef.scrollToElement('#otsc-ua-report-overview');
          }
          break;
        }
      }
    }
    
    this.componentTableRows.forEach((tableRow:DataTableRow) => {
      if(tableRow.data.macAddress == row.data.macAddress && tableRow.data.installPath == row.data.installPath){
        tableRow.data.viewReportSelected = true;
      }else{
        tableRow.data.viewReportSelected = false;
      }
    });
  }

  onPageChange(pageEvent: PageEvent) {
    this.getUAFiles(pageEvent.itemsPerPage, pageEvent.startingIndex, this.sortingCol);
  }

  getUAFiles(pageSize: number, startIndex: number, sortingCol:DataTableColumn) {
    this.uaTableRows = [];
    this.itemsPerPage = pageSize < 0 ? PageCount.TWENTYFIVE : pageSize;
    this.startingIndex = startIndex < 0 ? 0 : startIndex;
    this.sortingCol = sortingCol;
    this.currentDeltaReport.updateReportDataFiles.sort((a, b) => (a[sortingCol.field] > b[sortingCol.field] ? (sortingCol.sortDirection == ColumnSort.DESC) ? 1 : -1 :
                                                                                                              (sortingCol.sortDirection == ColumnSort.DESC) ? -1 : 1 ))
                                                 .slice(startIndex, startIndex + pageSize).forEach(file => {
                                                    this.uaTableRows.push(new DataTableRow(file, []));
                                                  });
  }
  
  sortUAFiles(selectedCol:DataTableColumn){
    this.getUAFiles(this.itemsPerPage, this.startingIndex, selectedCol);
  }

  resetUACols():void {
    this.uaTableCols.forEach((col:DataTableColumn) => {
      if(col.field !== this.sortingCol.field){
        col.sorted = false;
      }
    });
  }

  goBack():void {
    this.state = UAState.INIT;
  }

  onUAReportTabChange(selectedIndex: number) {
    let stateid: any = this.uaReportTabs[selectedIndex].id;
    stateid = stateid.replaceAll("-tabitem", "");
    this.uaReportActiveTab = selectedIndex;
    this.setUAReportState(this.uaReportActiveTab, stateid);
  }

  setUAReportState(state:UAReportState, id:string): void {
    this.uaReportState = state;
    if(this.scrollRef !== undefined){
      this.scrollRef.scrollToElement('#' + id);
    }
  }

  availablePatchChange(event): void {
    this.targetUpdate = this.availablePatches[event.target.selectedIndex];
  }
  
  selectToAnalyze(row:DataTableRow): void {
    let index = this.componentTableRows.findIndex((compRow:DataTableRow) => {
      return compRow.data.macAddress == row.data.macAddress && compRow.data.installPath == row.data.installPath
    })

    if(index > -1){
      let compRow:DataTableRow = this.componentTableRows[index];
      let selectedInstanceIndex = this.selectedInstanceRows.findIndex((instanceRow:DataTableRow) => {
        return instanceRow.data.macAddress == compRow.data.macAddress && instanceRow.data.installPath == compRow.data.installPath;
      });
  
      if(compRow.selected && selectedInstanceIndex < 0){
        this.selectedInstanceRows.push(compRow);
      }else if(!compRow.selected && selectedInstanceIndex > -1){
        this.selectedInstanceRows.splice(selectedInstanceIndex, 1);
      }
    }
  }

  selectAllToAnalyze(rows:DataTableRow[]): void{
    rows.forEach((row:DataTableRow) => {
      this.selectToAnalyze(row);
    });
  }

  analyze():void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Update analysis confirmation`,
          message: $localize`Analysis of the selected ${this.selectedInstanceRows.length} instance(s) could take several minutes to complete. Would you like to perform analysis of the selected instances?`,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '350px'
        },
        id: 'otsc-products-ua-confirm-msg'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.uaReportNumInstances = 0;
          this.uaReportNumInstancesError = 0;

          this.componentTableRows.forEach((row: DataTableRow) => {
            row.disableCheckbox = true;
            if (row.selected) {
              row.data.viewReport = '';
              row.loading = true;
              this.uaReportNumInstances++;
            }
          });

          if (this.selectedInstanceRows.length > 0) {
            this.selectedInstanceRows.forEach((row: DataTableRow) => {
              let instance: any = new Object();
              instance.OTHome = row.data.instance.installPath;
              instance.status = new TaskStatus();
              instance.status.setAsRunning();

              if (this.uaRequestMap[row.data.macAddress]) {
                //remove existing one
                let index: number = this.uaRequestMap[row.data.macAddress].instances.findIndex((existingInstance: any) => {
                  return existingInstance.OTHome == instance.OTHome;
                })

                if (index > -1) {
                  this.uaRequestMap[row.data.macAddress].instances.splice(index, 1);
                }

                this.uaRequestMap[row.data.macAddress].instances.push(instance);
                this.uaRequestMap[row.data.macAddress].targetUpdateLevel = this.targetUpdate.patchLevel;
                this.uaRequestMap[row.data.macAddress].targetUpdateName = this.targetUpdate.name;
              } else {
                let uaRequest: any = new Object();
                uaRequest.targetUpdateLevel = this.targetUpdate.patchLevel;
                uaRequest.targetUpdateName = this.targetUpdate.name;
                uaRequest.currentUpdateName = this.currentUpdate.name;
                uaRequest.status = new TaskStatus();
                uaRequest.status.setAsRunning();
                uaRequest.systemName = row.data.system;
                uaRequest.macAddress = row.data.macAddress;
                uaRequest.instances = [];
                uaRequest.instances.push(instance);
                this.uaRequestMap[row.data.macAddress] = uaRequest;
              }
            });

            setTimeout(() => {
              this.siService.sendUpdateAnalysis(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
              new UpdateAnalysisRequest(this.uaRequestMap, this.setupid, this.activeProduct.version, this.solutionInfo.currentEnvironment.id,
                this.targetUpdate.productGroupId)).pipe(
                tap(resp => {
                  this.isAnalyzing = true;
                  this.isAnalyzed = false;
                }),
                catchError(resp => {
                  Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "UPDATE_ANALYSIS", undefined);
                  this.componentTableRows.forEach((instanceRow:DataTableRow) => {
                    instanceRow.loading = false;
                  });
                  this.isAnalyzing = false;
                  this.isAnalyzed = false;
                  return of(resp);
                })).subscribe();
            }, 1000);

          }
        }
        sub.unsubscribe();
      });
  }
  
  isUAComplete():boolean {
    let isCompleted:boolean = true;

    for (let uaRequest of Object.values(this.uaRequestMap)) {
      if(!uaRequest.status.completed){
        isCompleted = false;
        break;
      }
    }

    return isCompleted;
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.openDetails(event.data[0]);
    }
  }

  back():void {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  viewError():void {
    let rows:DataTableRow[] = [];

    for (let uaRequest of Object.values(this.uaRequestMap)) {
      uaRequest.instances.forEach((instance:any, index:number) => {
        if(instance.status.completed && !instance.status.success){
          let msg:string;

          if(instance.status.errorCode == 'UA_OTHOME_NOT_FOUND'){
            msg = $localize`Unable to find an instance by the installation path.`;
          }else if(instance.status.errorCode == 'UA_UNABLE_TO_SEND_REQ_ERROR'){
            msg = $localize`Unable to send a request to perform update analysis. Please try again.`;
          }else if(instance.status.errorCode == 'UA_PROCESS_ERROR'){
            msg = $localize`Unable to perform an update analysis. Please try again.`;
          }
          
          let row:DataTableRow[] = this.componentTableRows.filter((row:DataTableRow) => {
            return row.data.macAddress == uaRequest.macAddress;
          });

          if(row.length > 0){
            rows.push(new DataTableRow({system: row[index].data.system,
                                        installPath: row[index].data.installPath,
                                        message: msg}, [])); 
          }
        }
      });
    }

    this.modal.open(ProductResyncComponent, {
      data: {rows: rows, title: $localize`Update analysis errors`, message: $localize`The following instances failed to analyze.`, id: "otsc-product-ua-error-dlg"},
      id: 'otsc-products-ua-error-dialog'
    })
  }

  private getAgentStatus(agent:Agent): any {
    let agentStatus:any;

    if(agent == undefined){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    //disabled
    }else if(!agent.isActive){
      agentStatus = {className: 'otsc-icon-status-closed', altText: $localize`Agent is disabled`};
    //idle
    }else if(agent.isActive && agent.isOnline && !agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-away', altText: $localize`Agent is idle`};
    //busy
    }else if(agent.isActive && agent.isOnline && agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-busy', altText: $localize`Agent is busy`};
    //offline
    }else if(agent.isActive && !agent.isOnline){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    }

    return agentStatus;
  }

  private openDetails(data: any): void{
    this.modal.open(InstanceDetailsComponent, {
      data: {
        instanceMetaData: JSON.parse(data.instance ? data.instance.metadata : data.metadata),
        productName: this.activeProduct.name + ' ' + this.activeProduct.version,
        supportHotfix: this.isSupportHotfix,
        id: 'otsc-products-ua-details-dialog'
      }
    });
  }

  rowClick(event: any): void{
    this.openDetails(event.data);
  }

  isError(): boolean {
    return (this.isSupportHotfix && this.isMasterSystemOnline && this.isQuickAnalysisRequired) || 
    (this.isSupportHotfix && this.isMasterSystemOnline && !this.isQuickAnalysisRequired && !this.isMasterSystemSelected)
      || (!this.isMasterSystemOnline);
  }

  analyzeMasterSystemClicked(): void {
    this.getEnableProductCapabilities(this.solutionInfo, this.activityCapabilities, this.activeProduct);
  }
}